import {VALUES} from '../../constants/values'

export function GhostActor(): React.ReactElement {
  return <span>{VALUES.ghost.login} </span>
}
